import React from 'react';
import { FormCouponGift, Loader, useForm } from '/src/components';
import {
    useCartContext,
    useModalsContext,
    useStoreConfigContext,
} from '/src/providers';

const Coupon = () => {
    const { translate } = useStoreConfigContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const {
        cart: { id: cartId },
        isLoadingCart,
        applyCouponToCart,
    } = useCartContext();
    const { data, handleChange } = useForm({ coupon: '' });

    const handleSubmit = e => {
        e.preventDefault();

        applyCouponToCart({
            input: {
                cart_id: cartId,
                coupon_code: data.coupon,
            }
        }).then(() => {
            handleChange({ target: { name: 'coupon', value: '', type: 'text' } });
        }).catch(errors => showModal(MODALS_TYPES.ERROR, { errors }))
    };

    return (
        <Loader isLoading={isLoadingCart}>
            <FormCouponGift
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                name="coupon"
                data={data.coupon}
                isLoading={isLoadingCart}
                translate={translate}
            />
        </Loader>
    )
};

export default Coupon;
